'use client'

interface ModeToggleProps {
  mode: 'cut' | 'roll'
  rollPrice: number
  onSelectMode: (mode: 'cut' | 'roll') => void
}

// Both halves carry a border, not just the unselected one: without it the lime
// half was 2px shorter than its neighbour and the control sat crooked.
const BASE =
  'border px-4 py-2 text-sm font-medium transition-colors'
// Teal pairing rule: teal is a fill that carries white text. The
// accent-foreground token is the white the rest of the site pairs with the
// accent fill (contrast against the new teal not yet re-verified).
const SELECTED = 'bg-accent border-accent text-accent-foreground'
const UNSELECTED = 'border-divider text-foreground hover:bg-surface-secondary'

export function ModeToggle({ mode, rollPrice, onSelectMode }: ModeToggleProps) {
  return (
    <div role="radiogroup" aria-label="Purchase mode" className="inline-flex">
      <button
        type="button"
        role="radio"
        aria-checked={mode === 'cut'}
        className={`rounded-l-lg ${BASE} ${mode === 'cut' ? SELECTED : UNSELECTED}`}
        onClick={() => onSelectMode('cut')}
      >
        Cut to length
      </button>
      <button
        type="button"
        role="radio"
        aria-checked={mode === 'roll'}
        className={`-ml-px rounded-r-lg ${BASE} ${mode === 'roll' ? SELECTED : UNSELECTED}`}
        onClick={() => onSelectMode('roll')}
      >
        Full roll: ${rollPrice.toLocaleString('en-CA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}
      </button>
    </div>
  )
}
